import _classCallCheck from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// 通用接口返回
// 安卓调用 JS 方法时的参数
// 兼容 Node 环境的判断
var isNode = typeof window === 'undefined' || typeof navigator === 'undefined';
var ua = isNode ? '' : navigator.userAgent;
var isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
function setupWebViewJavascriptBridgeInIOS(callback) {
  if (window && Object.hasOwnProperty.call(window, 'WebViewJavascriptBridge')) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window && Object.hasOwnProperty.call(window, 'WVJBCallbacks')) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'xiaopeng://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}
function setupWebViewJavascriptBridgeInAndroid(callback) {
  if (window && Object.hasOwnProperty.call(window, '_dsbridge')) {
    setTimeout(function () {
      return callback(window._dsbridge);
    }, 0);
    return;
  }
}
function isHybird() {
  var userAgent = isNode ? '' : navigator.userAgent.toLowerCase();
  return userAgent.indexOf('xiaopeng') !== -1;
}
function setupWebViewJavascriptBridge(callback) {
  if (isAndroid) setupWebViewJavascriptBridgeInAndroid(callback);else setupWebViewJavascriptBridgeInIOS(callback);
}
/**
 * 用于 APP 内的 JSBridge 便捷调用的 sdk
 * 设计 applyStack & registerStack用于将 bridge 初始化前的调用缓存起来，在 bridge 初始化后补充调用
 */

export var JSBridge = /*#__PURE__*/function () {
  function JSBridge() {
    _classCallCheck(this, JSBridge);
    _defineProperty(this, "_bridge", void 0);
    _defineProperty(this, "_applyStack", void 0);
    _defineProperty(this, "_promisePool", void 0);
    _defineProperty(this, "_registerStack", void 0);
    _defineProperty(this, "_isRegisterHandlerBridgeInit", void 0);
    _defineProperty(this, "_androidHandlerPool", void 0);
    _defineProperty(this, "_isExternalChannel", void 0);
    _defineProperty(this, "_externalChannelHandler", void 0);
    _defineProperty(this, "_internalChannelHandler", void 0);
    this._applyStack = [];
    this._promisePool = {};
    this._registerStack = [];
    this._isRegisterHandlerBridgeInit = false;
    this._androidHandlerPool = {};
    this.handleMessageFromNative = this.handleMessageFromNative.bind(this);
    this._isExternalChannel = isHybird();
    this._externalChannelHandler = function () {};
    this._internalChannelHandler = function () {}; // 非 webview 不执行初始化，避免 iOS 浏览器中加载 xiaopeng://__bridge_loaded 而唤起 APP

    if (isHybird()) {
      this.initJavascriptBridge();
    }
  }
  _createClass(JSBridge, [{
    key: "isAndroid",
    get: function get() {
      return isAndroid;
    } // 初始化bridge
  }, {
    key: "initJavascriptBridge",
    value: function initJavascriptBridge() {
      var _this = this;
      var callExternalChannelHandlerTimeout = setTimeout(function () {
        _this._externalChannelHandler();
        _this._isExternalChannel = true;
      }, 1000);
      setupWebViewJavascriptBridge(function (bridge) {
        clearTimeout(callExternalChannelHandlerTimeout);
        _this._isExternalChannel = false;
        _this._internalChannelHandler();
        _this._bridge = bridge;
        _this.runStack();
        _this.registerStack();
      });
    } // 调起客户端方法
  }, {
    key: "applyMethod",
    value: function applyMethod(methodName, params) {
      var _this2 = this;
      var promiseId = "XPengMethod".concat(Math.floor(Math.random() * 100000));
      this._applyStack.push({
        methodName: methodName,
        params: params,
        promiseId: promiseId
      });
      return new Promise(function (resolve) {
        _this2._promisePool[promiseId] = resolve;
        if (!_this2._bridge || _this2._applyStack.length !== 1) return;
        _this2.run(_this2._applyStack.pop());
      });
    } // 触发单个调用
  }, {
    key: "run",
    value: function run(mission) {
      if (isAndroid) {
        mission.params = {
          data: mission.params
        };
        this.runInAndroid(mission);
      } else this.runInIOS(mission);
    }
  }, {
    key: "runInAndroid",
    value: function runInAndroid(mission) {
      var applyParams = mission.params; // 安卓客户端通过 _dscbstub 参数来决定调用 window 下的方法名

      if (Object.hasOwnProperty.call(mission, 'promiseId')) {
        window[mission.promiseId] = this._promisePool[mission.promiseId];
        applyParams['_dscbstub'] = mission.promiseId;
        this._promisePool[mission.promiseId] = undefined;
      }
      this._bridge.call(mission.methodName, JSON.stringify(applyParams));
    }
  }, {
    key: "runInIOS",
    value: function runInIOS(mission) {
      this._bridge.callHandler(mission.methodName, mission.params, this._promisePool[mission.promiseId]);
      this._promisePool[mission.promiseId] = undefined;
    } // 触发调用栈
  }, {
    key: "runStack",
    value: function runStack() {
      while (this._applyStack.length) {
        var mission = this._applyStack.pop();
        this.run(mission);
      }
    } // 设置可供客户端调用的响应
  }, {
    key: "registerHandler",
    value: function registerHandler(method, handler) {
      if (isAndroid) this.registerHandlerInAndroid(method, handler);else this.registerHandlerInIOS(method, handler);
    } // 调用原生方法
  }, {
    key: "callHandler",
    value: function callHandler(method) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.applyMethod(method, params);
    } // 安卓注册方法供原生调用
  }, {
    key: "registerHandlerInAndroid",
    value: function registerHandlerInAndroid(name, handler) {
      // 安卓原生调用的流程如下：
      // 1. JS调用原生的_dsb.dsinit方法
      // 2. 原生调用window._handleMessageFromNative方法
      // 3. JS调用原生的_dsb.returnValue方法返回值到客户端
      if (!this._isRegisterHandlerBridgeInit) {
        this.applyMethod('_dsb.dsinit', {}).then(function () {});
        window._handleMessageFromNative = this.handleMessageFromNative;
      }
      this._androidHandlerPool[name] = handler;
    } // 处理客户端原生调用_handleMessageFromNative方法
  }, {
    key: "handleMessageFromNative",
    value: function handleMessageFromNative(params) {
      var _this3 = this;
      if (Object.hasOwnProperty.call(this._androidHandlerPool, params.method)) {
        var handler = this._androidHandlerPool[params.method];
        var options = JSON.parse(params.data);
        var responseCallback = function responseCallback(newOptions) {
          console.table({
            id: params.callbackId,
            complete: true,
            data: newOptions
          });
          _this3._bridge.call('_dsb.returnValue', JSON.stringify({
            data: {
              id: params.callbackId,
              complete: true,
              data: newOptions
            }
          }));
        };
        handler(options, responseCallback);
      }
    } // iOS注册方法供原生调用
  }, {
    key: "registerHandlerInIOS",
    value: function registerHandlerInIOS(name, handler) {
      this._registerStack.push({
        name: name,
        handler: handler
      });
      if (!this._bridge || this._registerStack.length !== 1) return;
      this.register(this._registerStack.pop());
    } // 触发单个注册
  }, {
    key: "register",
    value: function register(mission) {
      this._bridge.registerHandler(mission.name, mission.handler);
    } // 触发注册栈
  }, {
    key: "registerStack",
    value: function registerStack() {
      while (this._registerStack.length) {
        var mission = this._registerStack.pop();
        this.register(mission);
      }
    } // 响应非客户端方式调起网页
  }, {
    key: "registerExternalChannelHandler",
    value: function registerExternalChannelHandler(handler) {
      this._externalChannelHandler = handler;
      if (!isHybird()) handler();
    } // 响应客户端方式调起网页
  }, {
    key: "registerInternalChannelHandler",
    value: function registerInternalChannelHandler(handler) {
      this._internalChannelHandler = handler;
      if (!isHybird()) handler();
    } // 获取当前是否内渠
  }, {
    key: "isExternalChannel",
    value: function isExternalChannel() {
      return this._isExternalChannel;
    }
  }]);
  return JSBridge;
}();
export default new JSBridge();